export class GlobalLabels {
	public static readonly abortText = "Vom Benutzer abgebrochen";
}